import { useState } from "react";
import RegistrationGate from "./RegistrationGate";
import StudentRegistration from "./StudentRegistration";  // your existing file

/**
 * RegistrationFlow
 * Renders the instructions gate first.
 * Once the user agrees & clicks proceed, shows the StudentRegistration form.
 */
export default function RegistrationFlow() {
  const [gatePassed, setGatePassed] = useState(false);

  if (!gatePassed) {
    return <RegistrationGate onProceed={() => setGatePassed(true)} />;
  }

  return <StudentRegistration />;
}